export default function sendDataToGtm (data) {
  // console.log('sending data: ' + JSON.stringify(data))
  window.dataLayer.push(data)
}
